<template>
<div class="text-center">
  <img style="width: 320px; height: 260px;" src="/images/startSubscription.png" alt="">
  <div>Bạn sẽ được dùng thử toàn bộ tính năng của Salework Chat trong 3 ngày !</div>
  <b-button variant="primary" class="my-3" @click="getStartSubscription">Bắt đầu dùng thử</b-button>
</div>
</template>

<script>
import api from "@/lib/callAPI";
export default {
  name: "StartSubscriptionModal",
  methods:{
    async getStartSubscription(){
      const body = {
        company_code: this.globalData.logged_in_user.company.code,
      }
      let result = await api.post('/auth/getStartSubscription', body);
      if(result.success){
        window.location.reload();
      }
    }
  }
}
</script>

<style scoped>

</style>